import React from 'react';

import { Table as BootstrapTable } from 'react-bootstrap';

import styles from './Table.module.scss';

export const Table: React.FC = ({ children, ...props }) => (
  <BootstrapTable bordered className={styles.bookTable} {...props}>
    {children}
  </BootstrapTable>
);
